import _ from 'lodash'
import {
  DATE_TYPE,
  DATE_TYPE_SIZE
} from '../constants/globalTypes'

/**
 * 根據輸入的日期類型計算數量
 * @param {number} days 日數
 * @param {string} dateType 日期類型
 */
export const calculateCountsByDateType = (days, dateType) => {
  const calculatedDays = _.flow(
    days => _.divide(days, DATE_TYPE_SIZE[dateType]),
    _.floor
  )(days)
  return calculatedDays
}

/**
 * 根據輸入的年月日計算日數總和
 * @param {Object} inputGroupDate 輸入的日期物件，有年 (years) 月 (months) 日 (days)
 */
export const calculateDaysFromDateType = (inputGroupDate) => {
  const {
    years = 0,
    months = 0,
    days = 0
  } = inputGroupDate
  const totalDays = _.sum([
    years * DATE_TYPE_SIZE[DATE_TYPE.YEAR],
    months * DATE_TYPE_SIZE[DATE_TYPE.MONTH],
    +days
  ])
  return totalDays
}

/**
 * 根據輸入的日數計算年月日各有幾天
 * @param {number} days 日數
 */
export const groupDaysByDateType = (inputDays) => {
  const PER_YEAR = DATE_TYPE_SIZE[DATE_TYPE.YEAR]
  const PER_MONTH = DATE_TYPE_SIZE[DATE_TYPE.MONTH]
  let uncalculatedDays = inputDays
  let years = 0
  let months = 0
  let days = 0
  if (_.isNumber(inputDays)) {
    if (uncalculatedDays >= PER_YEAR) {
      years = calculateCountsByDateType(uncalculatedDays, DATE_TYPE.YEAR)
      uncalculatedDays -= years * PER_YEAR
    }
    if (uncalculatedDays >= PER_MONTH) {
      months = calculateCountsByDateType(uncalculatedDays, DATE_TYPE.MONTH)
      uncalculatedDays -= months * PER_MONTH
    }
    if (uncalculatedDays > 0) {
      days = uncalculatedDays
    }
  }
  return { years, months, days }
}
